import useSWR from "swr";
import { useSDK } from "@contentful/react-apps-toolkit";
import { FetchProps, swrKeys } from "../lib";
import { usePostDeepl } from "./";
import { UsageResponse } from "./types";

const DeeplUsageFetcher = async (
    postDeepl: (path: string, body: string | null, version: "v2" | "v3") => Promise<any>
): Promise<UsageResponse> => {
    const response = await postDeepl("usage", null, "v2");

    if (!response || !response.character_limit) {
        throw new Error("Error fetching usage");
    }

    return response;
};

export const useFetchDeeplUsage = (props?: FetchProps) => {
    const { skip } = props ?? {};
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const { postDeepl } = usePostDeepl();

    const { data, error, isLoading, mutate } = useSWR(
        [swrKeys.deeplUsage, deeplCredentials, !!skip],
        () => (!skip ? DeeplUsageFetcher(postDeepl) : undefined),
        { revalidateOnMount: true }
    );

    return {
        data,
        error,
        isLoading,
        mutate,
    };
};
